import { defineMessages } from 'react-intl';

export const scope = 'maintenance_mode_page';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'MAINTENANCE',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'This site is currently in maintenance mode',
  },
});
